export function getDTMFforKey(key: string) {
    switch (key) {
        case '1':
            return '1209, 697';
        case '2':
            return '1336, 697';
        case '3':
            return '1477, 697';
        case '4':
            return '1209, 770';
        case '5':
            return '1336, 770';
        case '6':
            return '1477, 770';
        case '7':
            return '1209, 852';
        case '8':
            return '1336, 852';
        case '9':
            return '1477, 852';
        case '0':
            return '1336, 941';
        default:
            return '1209, 697';
    }
}
